const BLOG_LOGO = 'https://static.readdy.ai/image/93c1453b8d97f37ee192728204451975/bb6f6c853cb367ec27cf1bd203bc1cd6.png';
const PROFILE_IMAGE = 'https://storage.readdy-site.link/project_files/616267ca-ed69-4edd-b285-3e91811f8940/5c3aebaa-772d-402f-801c-bef6766a5d2c_2.png?v=45e18de3248247f90da7dcb04afa79e0';

export default function HeroSection() {
  return (
    <>
      {/* Hero section */}
      <section className="w-full bg-white pt-16 pb-6 px-6">
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center">

          {/* Profile image */}
          <div className="w-32 h-32 rounded-full overflow-hidden border border-[#E8E8E8] mb-7 flex-shrink-0">
            <img
              src={PROFILE_IMAGE}
              alt="たか / Number84 プロフィール"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Name */}
          <h1 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] tracking-wide mb-2 animate-fade-in-up">
            たか / Number84
          </h1>

          {/* Title */}
          <p className="text-sm md:text-base font-normal text-[#6B6B6B] tracking-widest mb-6 animate-fade-in-up animate-delay-100">
            暮らしのコーディネーター
          </p>

          {/* SNS Links */}
          <div className="flex items-center gap-4 mb-5 animate-fade-in-up animate-delay-150">
            <a href="https://www.instagram.com/__number84/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors" aria-label="Instagram">
              <i className="ri-instagram-line text-xl" />
            </a>
            <a href="https://x.com/Number84M" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors" aria-label="X">
              <i className="ri-twitter-x-line text-xl" />
            </a>
            <a href="https://www.tiktok.com/@number84m" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors" aria-label="TikTok">
              <i className="ri-tiktok-line text-xl" />
            </a>
            <a href="https://www.youtube.com/@Number84M" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors" aria-label="YouTube">
              <i className="ri-youtube-line text-xl" />
            </a>
            <a href="https://number84log.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors" aria-label="ブログ">
              <i className="ri-article-line text-xl" />
            </a>
          </div>

          {/* Short intro */}
          <p className="text-[15px] md:text-base leading-relaxed text-[#4A4A4A] max-w-md mb-10 animate-fade-in-up animate-delay-200">
            <span className="block">暮らしが少し整い、毎日が快適になるヒントをお届けします。</span>
          </p>

          {/* Divider */}
          <div className="w-8 h-px bg-[#E0E0E0] mt-6" />
        </div>
      </section>
    </>
  );
}
